/**
 * Main application entry point.
 */

'use strict';

var app = require('mag-app'),
    config = require('./config');


if ( PLATFORM === 'MAG' ) {
    app.numpad = false;
    app.onVkNeedReposition = function ( type ) {
        var sizes = config[screen.height].main,
            left = sizes.left,
            top = sizes.top,
            input;

        if ( app.numpad ) {
            sizes = config[screen.height].numpad;
            left = sizes.left;
            top = sizes.top;
        }

        /* eslint new-cap: 0 */
        input = JSON.parse(window.top.stbWindowMgr.GetFocusedInputInfo());
        input.result.y = parseInt(input.result.y, 10);
        input.result.h = parseInt(input.result.h, 10);
        top = input.result.y + input.result.h;
        if ( top === 0 ) {
            top = screen.height - sizes.height - sizes.top;
        } else if ( top + sizes.height > window.screen.height ) {
            // move to bottom
            top = input.result.y - sizes.height;
        }

        if ( !type ) {
            type = input.result.positionHint;
        }

        switch ( type ) {
            case 'topleft':
            case 'topright':
            case 'top':
                top = sizes.top;
                break;
            case 'bottomleft':
            case 'bottomright':
            case 'bottom':
                top = screen.height - sizes.height - sizes.top;
                break;

            case 'none':
            default:
                // automatic
                break;
        }

        window.top.stbWebWindow.SetGeometry(left, top, sizes.width, sizes.height);
    };


    if ( window.top.stbEvent ) {
        window.top.stbEvent.onVkNeedReposition = app.onVkNeedReposition;
    } else {
        window.top.stbEvent = {onVkNeedReposition: app.onVkNeedReposition};
    }
}


// everything is ready
app.once('load', function () {
    var lang = require('./modules/lang'),
        list = window.core.plugins.keyboardLayouts.get(),
        codes = [],
        fullNames = [],
        shortNames = [];

    console.log(JSON.stringify(list));
    // window.top.confirm(1);
    if ( list && list.length > 0 ) {
        list.forEach(function ( code ) {
            var index = lang.supportedCodes.indexOf(code);

            if ( index !== -1 ) {
                codes.push(lang.supportedCodes[index]);
                fullNames.push(lang.supportedFullNames[index]);
                shortNames.push(lang.supportedShortNames[index]);
            }
        });

        lang.codes = codes;
        lang.fullNames = fullNames;
        lang.shortNames = shortNames;
    }

    lang.active = lang.codes.indexOf(core.environment.language);

    if ( lang.active === -1 ) {
        lang.active = 0;
    }
    if ( PLATFORM === 'MAG' ) {
        window.parent.gSTB.SetInputLang(lang.codes[lang.active]);
    }

    require('spa-gettext').load({name: core.environment.language}, function ( error ) {
        if ( error ) {
            // make it global
            // window.ngettext = window.gettext  = window._ = function ( msgId ) {
            //     return msgId;
            // };
            // window.pgettext = function ( context, msgId ) {
            //     return msgId;
            // };
        }

        if ( PLATFORM === 'MAG' ) {
            // load pages
            app.pages = {
                main: require('./pages/main'),
                qwerty: require('./pages/qwerty')
            };

            // show main page
            if ( app.query.standalone && app.query.standalone === 'true' ) {
                app.route(app.pages.qwerty);
            } else {
                app.route(app.pages.main);
            }
        } else {
            app.pages = {
                main: require('./pages/main')
            };
            app.route(app.pages.main);
        }

        if ( PLATFORM === 'MAG' ) {
            if ( window.top.location.href.indexOf('load=true') !== -1 ) {
                window.top.stbWebWindow.close();
                // window.top.gSTB.HideVirtualKeyboard();
                // window.top.stbWindowMgr.hideWindow(window.top.stbWebWindow.windowId());
                // window.top.stbWindowMgr.windowHide(window.top.stbWebWindow.windowId());
            }
        }

        // send ready event
        app.ready();
    });

    //if ( DEVELOP ) {
    //    window.core.addListener('keydown:76', function () {
    //        if ( app.visible ) {
    //            window.core.call('hide');
    //            window.core.call('blur');
    //            app.visible = false;
    //        } else {
    //            app.visible = true;
    //            window.core.call('show');
    //            window.core.call('focus');
    //        }
    //    });
    //}
});
